/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_Edit_LabelInputs */



/**
* | output |
* | --- |
* | "Edit key" |
*
* @param {Options_Api_Keys_Edit_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_edit_label = /** @type {((inputs?: Options_Api_Keys_Edit_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_Edit_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier la clé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bearbeiten Sie den Schlüssel")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modifica chiave")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Редактировать ключ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tecla de edición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("编辑键")
	if (locale === "ja") return /** @type {LocalizedString} */ ("編集キー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपादन कुंजी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tecla de edição")
	return /** @type {LocalizedString} */ ("Edit key")
});